import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { billingStatuses } from '../constants'

const StatusSelector = ({ onChange, value = [] }) => {
  const { t } = useTranslation()

  const toggleOption = e => {
    onChange(e.target.value)
  }

  return (
    <div>
      <ComboBox
        menuItems={billingStatuses.map(s => ({ label: t(s.label), value: s.value }))}
        value={value || []}
        multiple
        fullWidth
        label={t('Estado factura')}
        handleChange={toggleOption}
        placeholder={t('Todos')}
      />
    </div>
  )
}

export default StatusSelector
